export default __webpack_public_path__ + "static/media/Exterior (5).53acb48e.jpg";